import PropTypes from 'prop-types'
import React from 'react'
import InstitutionToReferCitizenField from '../procedure_managements/InstitutionToReferCitizenField'

const Citizen = props => {
  const { index, name, question, disabled = false, margin } = props
  return <InstitutionToReferCitizenField index={index} {...question} name={name} disabled={disabled} margin={margin} />
}

const InstitutionToReferQuestion = {
  Citizen,
  name: 'InstitutionToReferQuestion'
}

export default InstitutionToReferQuestion

Citizen.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  margin: PropTypes.string,
  name: PropTypes.string,
  question: PropTypes.object
}
